import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "../form/select/Select";
import * as Yup from "yup";
import { getAllActiveRoles } from "../../redux/slice/roles/roleSlice";
import {
  assignPermissions,
  getPermissions,
  resetPermission,
} from "../../redux/slice/permission/permissionSlice";
import { BounceLoader } from "react-spinners";
import { BsInfo } from "react-icons/bs";

const modules = [
  { id: 1, name: "Accounting" },
  { id: 2, name: "User" },
  { id: 3, name: "Customer" },
  { id: 4, name: "Office" },
  { id: 5, name: "Staff" },
  { id: 6, name: "Settings" },
  { id: 7, name: "Policy" },
  { id: 8, name: "Report" },
  { id: 9, name: "Workflow" },
  { id: 10, name: "Claim" },
];
const Permissions = () => {
  const { active_roles } = useSelector((state) => state.role);
  const { all_permissions, isLoading, assignSuccess, isSuccess } = useSelector(
    (state) => state.permission
  );
  const { user_permissions } = useSelector((state) => state?.auth?.user);

  const [permissionSelect, setPermissionSelect] = useState();
  const [hasUpdatePermission, setHasUpdatePermission] = useState();
  const dispatch = useDispatch();

  const onSubmit = (values) => {
    let payload = { ...values, permissions: permissionSelect };
    dispatch(assignPermissions(payload));
  };

  const validationScehma = Yup.object().shape({
    role_id: Yup.string("Role must be a string").required(
      "Role cannot be blank"
    ),
    module_id: Yup.string("Module must be a string").required(
      "Module cannot be blank"
    ),
  });

  const { values, errors, touched, handleBlur, handleSubmit, setFieldValue } =
    useFormik({
      enableReinitialize: true,
      initialValues: {
        role_id: 6 || "",
        module_id: 1 || "",
      },
      validationSchema: validationScehma,
      onSubmit,
    });

  const handlePermissionSelect = (e, id) => {
    let object = { name: e.target.value, checked: e.target.checked };
    if (!object.checked) {
      let sorted = permissionSelect.filter((item) => item.name !== object.name);
      setPermissionSelect(sorted);
    } else
      setPermissionSelect([
        ...permissionSelect,
        { name: object.name, id: id, module_id: values.module_id },
      ]);
  };

  // Function to handle checking all checkboxes
  const checkAllCheckboxes = () => {
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = true;
    });
    const allPermissions = all_permissions?.permission_by_module_id || [];
    const selectedPermissions = allPermissions.map((item) => ({
      name: item.name,
      id: item.id,
      module_id: values.module_id,
    }));
    setPermissionSelect(selectedPermissions);
  };

  // Function to handle unchecking all checkboxes
  const uncheckAllCheckboxes = () => {
    const checkboxes = document.querySelectorAll('input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      checkbox.checked = false;
    });
    setPermissionSelect([]);
  };



  const rolesData = active_roles?.roles?.map((role) => {
    return {
      label: role.name,
      value: role.id,
    };
  });

  const modulesData = modules?.map((module) => {
    return {
      label: module.name,
      value: module.id,
    };
  });

  useEffect(() => {
    dispatch(getAllActiveRoles());
  }, [dispatch]);

  useEffect(() => {
    const requestData = { module: values.module_id, role_id: values.role_id };

    dispatch(getPermissions(requestData));

    return () => {
      dispatch(resetPermission());
    };
  }, [dispatch, values.module_id, values.role_id]);

  useEffect(() => {
    const requestData = { module: values.module_id, role_id: values.role_id };

    if (assignSuccess) {
      dispatch(getPermissions(requestData));
      dispatch(resetPermission());
    }
  }, [assignSuccess, dispatch, values.module_id, values.role_id]);

  useEffect(() => {
    const permissions = all_permissions?.permission_by_role?.map((item) => {
      return { name: item.name, id: item.id, module_id: values.module_id };
    });

    setPermissionSelect(permissions);
  }, [all_permissions?.permission_by_role, values.module_id]);

  useEffect(() => {
    setHasUpdatePermission(
      user_permissions?.some(
        (permission) => permission.name === "add/update permissions"
      )
    );
  }, [user_permissions]);

  let key = [
    ...new Set(
      all_permissions?.permission_by_module_id?.map((item) => item.sub_module)
    ),
  ];


  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className='row mb-2'>
          <div className='col-md-2 col-lg-1 text-end sm-text-end'>
            <label htmlFor='account_type' className={`form-label mt-1`}>
              Role <span className='text-danger'>*</span>
            </label>
          </div>

          <div className='col-sm-4'>
            <Select
              onBlur={() => {
                handleBlur({ target: { name: "role" } });
              }}
              name='role_id'
              data={rolesData}
              value={values?.role_id}
              onChange={(selectedOption) =>
                setFieldValue("role_id", selectedOption?.value)
              }
            />
            {errors?.role_id && touched?.role_id && (
              <p className='mb-0 text-danger'>{errors?.role_id + "*"}</p>
            )}
          </div>
        </div>
        <div className='row mb-4'>
          <div className='col-md-2 col-lg-1 text-end sm-text-end'>
            <label htmlFor='account_type' className={`form-label mt-1`}>
              Module <span className='text-danger'>*</span>
            </label>
          </div>

          <div className='col-sm-4'>
            <Select
              onBlur={() => {
                handleBlur({ target: { name: "module_id" } });
              }}
              name='module_id'
              data={modulesData}
              value={values?.module_id}
              onChange={(selectedOption) =>
                setFieldValue("module_id", selectedOption?.value)
              }
            />
            {errors?.module_id && touched?.module_id && (
              <p className='mb-0 text-danger'>{errors?.module_id + "*"}</p>
            )}
          </div>
        </div>

        {isLoading && !isSuccess ? (
          <div className='d-flex mt-lg-5 ps-5 align-content-center'>
            <BounceLoader color='#2E3192' size={"70px"} />
          </div>
        ) : (
          <div className='row mb-3'>
            <div className='row ps-5 mb-2'>
              <div className='col-sm-6 d-flex gap-3'>
                {permissionSelect && permissionSelect.length === all_permissions?.permission_by_module_id?.length ? (
                  <button
                    type='button'
                    className='btn btn-primary btn-sm px-4 rounded'
                    onClick={uncheckAllCheckboxes}
                  >
                    Uncheck All
                  </button>
                ) : (
                  <button
                    type='button'
                    className='btn btn-primary btn-sm px-4 rounded'
                    onClick={checkAllCheckboxes}
                  >
                    Check All
                  </button>
                )}
              </div>
            </div>
            {key?.map((item, i) => {
              const filteredPermission = all_permissions?.permission_by_module_id?.filter((el) => el.sub_module === item);
              return (
                <div className='mb-2 text-capitalize' key={i}>
                  <div style={{ width: "200px" }}>
                    <h5 className='mb-2 ps-3 text-right'>{item}</h5>
                  </div>
                  <div className=''>
                    {filteredPermission?.map((item, i) => (
                      <div
                        className='d-flex flex-row align-items-start  col-sm-12 gap-3 '
                        key={i}
                      >
                        <label
                          className='form-label col-md-4 col-lg-2 fw-normal'
                          htmlFor='superUser'
                          style={{
                            textAlign: "right",
                          }}
                        >
                          {item.name}
                        </label>
                        <input
                          className={`form-check-input`}
                          type='checkbox'
                          id={item.name}
                          value={item.name}
                          name={item.name}
                          onChange={(e) => handlePermissionSelect(e, item.id)}
                          style={{ height: "19px", width: "19px" }}
                          defaultChecked={all_permissions?.permission_by_role.some(
                            (roleItem) => roleItem.name === item.name
                          )}
                          disabled={values.role_id === 6}
                        />
                        {i === 0 && (
                          <span
                            type='button'
                            className='bg-secondary text-white rounded d-flex justify-content-center align-items-center'
                            data-toggle='tooltip'
                            data-placement='top'
                            title={`All permissions are dependent on ${item.name} permission. Make sure it is checked to access other permissions`}
                            style={{
                              height: "17px",
                              width: "17px",
                              marginTop: "3px",
                            }}
                          >
                            <BsInfo />
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              );
            })}
            <div className='row mt-3 ps-5'>
              <div className='col-sm-6 d-flex gap-3'>
                <button
                  type='submit'
                  className='btn btn-primary btn-sm px-4 rounded'
                >
                  Update
                </button>
                {/* <button
            type='button'
            className='btn btn-primary btn-sm px-4 rounded'
            onClick={checkAllCheckboxes} // Bind the function to the button click event
          >
            Check All
          </button> */}
              </div>
              <div className='col-sm-2'></div>
            </div>
          </div>
        )}
      </form>
    </>
  );
};

export default Permissions;
